import React, { FC, ReactElement } from 'react';
import { TableHeader, RowItems } from './components';
import { TableDataNotFound, InfoCircle, Loader } from 'components';
import { TOKEN_TAB, TOKEN_TAB_DESCRIPTIONS } from '../../../../../../../../constants';

import { useAppSelector } from 'store';
import { tableDataSort } from 'helpers';

import { ISortedParam } from 'types/interfaces';

import styles from './styles.module.scss';
import { topShareholdersMock } from './constants';
import { TableProBlur } from '../../../OrganizationTreasury/components/DaoAssetsTable/components/TableProBlur';

type TopTokenHoldersTableProps = {
    isPremiumAllowed: boolean;
};
export const TopTokenHoldersTable: FC<TopTokenHoldersTableProps> = ({ isPremiumAllowed }): ReactElement => {
    const { organizationTopShareholdersByHoldings, topShareholdersByHoldingsLoading } = useAppSelector(
        ({ organization }) => organization,
    );

    const [sortedParam, setSortedParam] = React.useState<ISortedParam>({
        paramName: 'tokenHolding',
        descending: true,
    });

    const sortByParam = (param: string) => {
        setSortedParam({
            paramName: param,
            descending: sortedParam.paramName === param ? !sortedParam.descending : true,
        });
    };

    const tableData = tableDataSort([...organizationTopShareholdersByHoldings], sortedParam);

    const dataToRender = organizationTopShareholdersByHoldings.length ? tableData : topShareholdersMock;

    return (
        <div className={styles.wrapper}>
            <div className={styles.tableWrapper}>
                <div className={styles.titleWrapper}>
                    <h4 className={styles.tableTitle}>Top Token Holders</h4>
                    <InfoCircle
                        tooltipText={TOKEN_TAB_DESCRIPTIONS[TOKEN_TAB.TOP_TOKEN_HOLDERS]}
                        className={styles.infoIcon}
                    />
                </div>
                <div style={{ position: 'relative' }}>
                    {topShareholdersByHoldingsLoading &&
                        organizationTopShareholdersByHoldings.length === 0 &&
                        isPremiumAllowed && (
                            <div className={styles.loaderBox}>
                                <Loader size={40} className={styles.similarUsersLoader} />
                            </div>
                        )}
                    {dataToRender.length > 0 && !topShareholdersByHoldingsLoading && (
                        <div className={styles.dataContainer}>
                            <div className={styles.tableContainer}>
                                <TableHeader sortByParam={sortByParam} sortedParamName={sortedParam.paramName} />

                                <div className={styles.rowsWrapper}>
                                    <div className={`${styles.rowsContainer} ${!isPremiumAllowed && styles.blur}`}>
                                        {dataToRender.map((currencyItems) => (
                                            <RowItems key={currencyItems.daoId} {...currencyItems} />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {!topShareholdersByHoldingsLoading &&
                        organizationTopShareholdersByHoldings.length === 0 &&
                        isPremiumAllowed && <TableDataNotFound forTable overflowMarginsSecondVariant />}
                    {!isPremiumAllowed && (
                        <div className={styles.blurWrapper}>
                            <TableProBlur
                                title="Top Token Holders is a DeepDAO Pro feature"
                                description={TOKEN_TAB_DESCRIPTIONS[TOKEN_TAB.TOP_TOKEN_HOLDERS]}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
